<template>
  <el-table
    :data="state.tableData"
    v-loading="!Array.isArray(state.tableData)"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <el-table-column label="#" type="index"></el-table-column>
    <el-table-column label="日志类型" width="100" align="center">
      <template #default="{ row }">
        <el-tag
          v-if="row._isHeXiao == true"
          type="success"
          size="small"
        >核销日志</el-tag>
        <el-tag
          v-else
          type="info"
          size="small"
        >操作日志</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="Czsj" label="操作时间"></el-table-column>
    <el-table-column prop="Czr" label="操作人"></el-table-column>
    <el-table-column prop="Nr" label="操作内容"></el-table-column>
  </el-table>
</template>

<script>
import { onMounted, reactive } from "vue";
import { shangpindingdan_getrz, hxjlList } from "@/http/api";
export default {
  props: {
    ddId: Number,
    orderBh: String,
  },
  setup(props) {
    const state = reactive({});
    onMounted(async () => {
      // 并行：操作日志 + 订单核销记录
      const [rzRes, hxRes] = await Promise.all([
        shangpindingdan_getrz(props.ddId),
        hxjlList({ DdId: props.ddId, PageIndex: 1, PageSize: 9999 }),
      ]);

      // 操作日志
      let rzList = [];
      if (rzRes?.status == 200 && Array.isArray(rzRes.data)) {
        rzList = rzRes.data.map((item) => ({ ...item, _isHeXiao: false }));
      }

      // 核销使用日志
      let hxList = [];
      if (hxRes?.status == 200) {
        const records = hxRes.data?.records || [];
        if (Array.isArray(records) && records.length > 0) {
          hxList = records.map((item) => ({
            Czsj: fmt(item.HeXiaoSj),
            Czr: item.HeXiaoRenXm || "-",
            Nr: buildContent(item),
            _isHeXiao: true,
          }));
        }
      }

      // 合并按时间排序
      state.tableData = [...rzList, ...hxList].sort((a, b) => {
        if (!a.Czsj) return 1;
        if (!b.Czsj) return -1;
        return a.Czsj > b.Czsj ? 1 : -1;
      });
    });

    const fmt = (v) => {
      if (!v) return "-";
      const s = String(v);
      return s.length >= 19 ? s.substring(0, 19).replace("T", " ") : s;
    };

    const buildContent = (row) => {
      const p = [];
      p.push(`核销 ${row.HeXiaoSl ?? 0} 份`);
      if (row.heXiaoLx) p.push(`方式：${row.heXiaoLx}`);
      if (row.shangHuMc) p.push(`商户：${row.shangHuMc}`);
      if (row.Bz) p.push(`备注：${row.Bz}`);
      return p.join("；");
    };

    return { state };
  },
};
</script>
<style scoped></style>
